<plotly-plot
  [divId]="divId"
  [data]="data"
  [layout]="layout"
  [config]="config"
  class="plot"
>
</plotly-plot>
@if (exportable) {
  <div class="flex w-full justify-center">
    <button
      mat-stroked-button
      (click)="handleExportClick()"
      class="mr-4 cursor-pointer text-xs text-gray-400 underline"
    >
      Export Graph
    </button>
  </div>
}
